import React, { memo } from 'react';
import { ModernVideoModelNode } from './ModernVideoModelNode';
import { SUPER_SEED_2_LITE_CONFIG } from './videoModelConfigs';

export const SuperSeed2LiteVideoNode = memo(props => (
  <ModernVideoModelNode {...props} config={SUPER_SEED_2_LITE_CONFIG} />
));
